// Unités de vente prédéfinies (le propriétaire peut aussi saisir une unité personnalisée
// dans la fiche produit). Les conditionnements viennent toujours de la fiche produit.
export const PREDEFINED_UNITS = [
  "unité", "pack", "carton", "bouteille", "bidon", "sac", "barre",
  "kilogramme", "tonne", "mètre", "mètre carré", "mètre cube", "camion",
];

// Options d'unité/conditionnement dérivées d'un produit (identique au POS).
export function unitOptions(p) {
  if (!p) return [];
  return [
    { key: "base", label: `À l'unité : ${p.base_unit}`, price: p.price, factor: 1 },
    ...(p.packagings || []).map((pk) => ({
      key: pk.name,
      label: `${pk.name} (× ${pk.factor} ${p.base_unit})`,
      price: pk.price ?? pk.factor * p.price,
      factor: pk.factor,
    })),
  ];
}

export function unitLabel(p, packaging) {
  if (packaging === "base") return p ? p.base_unit : "unité";
  return packaging || (p ? p.base_unit : "");
}

// Équivalences en conditionnement d'une quantité en unité de base — affichage SEUL, aucun calcul métier.
// Une ligne par conditionnement (alternatives, jamais additionnées). Avec `packaging`, seul celui-ci est utilisé.
// Ex. 57 kg → ["11 × sac 5 kg + 2 kg", "5 × sac 10 kg + 7 kg"]. Si le nom contient déjà la taille, elle n'est pas répétée.
export function packEquivLines(p, qty, packaging) {
  const q = Number(qty);
  if (!p || !(p.packagings || []).length || !Number.isFinite(q) || q <= 0) return [];
  const pks = (packaging && packaging !== "base") ? p.packagings.filter((pk) => pk.name === packaging) : p.packagings.filter((pk) => Number(pk.factor) > 1);
  const unit = p.base_unit || "";
  const fmt = (v) => String(Math.round(v * 1000) / 1000);
  return pks.map((pk) => {
    const f = Number(pk.factor); if (!(f > 0)) return null;
    const n = Math.floor(q / f); const rest = Math.round((q - n * f) * 1000) / 1000;
    if (n <= 0) return null;
    const name = String(pk.name || "").trim();
    const hasSize = new RegExp(`(^|\\D)${fmt(f)}(\\D|$)`).test(name);
    return `${n} × ${name}${hasSize ? "" : ` ${fmt(f)} ${unit}`}${rest > 0 ? ` + ${fmt(rest)} ${unit}` : ""}`;
  }).filter(Boolean);
}

export function packEquiv(p, qty, packaging) { return packEquivLines(p, qty, packaging).join(" · "); }

export function PackEquiv({ p, qty, packaging, className = "", compact = false }) {
  const lines = packEquivLines(p, qty, packaging);
  if (!lines.length) return null;
  return (
    <span className={`block font-normal text-[#64748B] ${compact ? "text-[10px] leading-[1.15] mt-0.5" : "text-[11px] leading-tight"} ${className}`} data-testid={`pack-equiv-${p.id}`}>
      {lines.map((l) => <span key={l} className="block whitespace-nowrap">{l}</span>)}
    </span>
  );
}
